/**
 * Analytics identifiers for TRAILER BUILD PLANS™.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '1017485148064545'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
